import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function Coal(props) {
    return (
        <SvgIcon viewBox="0 0 56 56" {...props} >
            <circle cx="28" cy="28" r="28" fill="white"/>
            <rect x="13.5557" y="23.3333" width="29.5556" height="14" fill="black"/>
            <rect x="12" y="20.2222" width="32.6667" height="4.66667" fill="black"/>
            <ellipse cx="28.3335" cy="22.5556" rx="13.2222" ry="8.55556" fill="black"/>
            <circle cx="19.0002" cy="38.1111" r="3.38889" fill="white" stroke="black"/>
            <circle cx="37.6672" cy="38.1111" r="3.38889" fill="white" stroke="black"/>
            <line x1="12" y1="41.5" x2="44.6667" y2="41.5" stroke="black"/>
        </SvgIcon>
    );
}